import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  exportGroup,
  exportUser,
  exportUserFriends,
  exportUserGroups,
  exportUserNext,
  getUserAvatar,
  selectAllUserInfo,
  selectChantRecord,
  selectGroupChantRecord,
  selectGroupList,
  selectGroupManList,
  selectNextList,
  selectUserBank,
  selectUserFriends,
  selectUserGoldDetails,
  selectUserGroup,
  selectUserInfo,
  selectUserMoney,
  selectUserSilverDetails,
  updateUserDetail,
  userReportConfig,
  fixReportStatus,
  circleOffrienesConfig,
  UpdateCoinFix,
  giftCoinDetails,
  updateMerchantDetail,
  selectDrawList,
  selectPrizeUserInfo,
  UpdatePrizeFix,
  drawPeriodList,
  prizesyncList
} from "@/api/modules/userManagement";

// 第一个参数为action，第二个参数为中间件处理的函数，一般用于发送axios请求
export const selectAllUserInfoAction = createAsyncThunk(
  "userManagement/selectAllUserInfo",
  async (params: any) => {
    // getUserChannels函数是一个axios的请求
    const result = await selectAllUserInfo(params);
    if (!result.error) return result.data;
    else {
      return Promise.reject(result.error);
    }
  }
);

// 获取奖品信息
export const selectPrizeUserInfoAction = createAsyncThunk(
  "userManagement/selectPrizeUserInfo",
  async (params: any) => {
    // getUserChannels函数是一个axios的请求
    const result = await selectPrizeUserInfo(params);
    if (!result.error) return result.data;
    else {
      return Promise.reject(result.error);
    }
  }
);


// 第一个参数为action，第二个参数为中间件处理的函数，一般用于发送axios请求
export const selectUserInfoAction = createAsyncThunk(
  "userManagement/selectUserInfo",
  async (params: any) => {
    // getUserChannels函数是一个axios的请求
    const result = await selectUserInfo(params);
    if (!result.error) return result.data;
    else {
      return Promise.reject(result.error);
    }
  }
);

export const selectUserBankAction = createAsyncThunk(
  "userManagement/selectUserBank",
  async (params: any) => {
    // getUserChannels函数是一个axios的请求
    const result = await selectUserBank(params);
    if (!result.error) return result.data;
    else {
      return Promise.reject(result.error);
    }
  }
);

// 第一个参数为action，第二个参数为中间件处理的函数，一般用于发送axios请求
export const selectUserMoneyAction = createAsyncThunk(
  "userManagement/selectUserMoney",
  async (params: any) => {
    // getUserChannels函数是一个axios的请求
    const result = await selectUserMoney(params);
    if (!result.error) return result.data;
    else {
      return Promise.reject(result.error);
    }
  }
);

// 第一个参数为action，第二个参数为中间件处理的函数，一般用于发送axios请求
export const selectUserGoldDetailsAction = createAsyncThunk(
  "userManagement/selectUserGoldDetails",
  async ({ id, params }: any) => {
    // getUserChannels函数是一个axios的请求
    const result = await selectUserGoldDetails(id, params);
    if (!result.error) return result.data;
    else {
      return Promise.reject(result.error);
    }
  }
);

// 第一个参数为action，第二个参数为中间件处理的函数，一般用于发送axios请求
export const selectUserSilverDetailsAction = createAsyncThunk(
  "userManagement/selectUserSilverDetails",
  async ({ id, params }: any) => {
    // getUserChannels函数是一个axios的请求
    const result = await selectUserSilverDetails(id, params);
    if (!result.error) return result.data;
    else {
      return Promise.reject(result.error);
    }
  }
);

// 第一个参数为action，第二个参数为中间件处理的函数，一般用于发送axios请求
export const selectUserFriendsAction = createAsyncThunk(
  "userManagement/selectUserFriends",
  async ({ id, params }: any) => {
    // getUserChannels函数是一个axios的请求
    const result = await selectUserFriends(id, params);
    if (!result.error) return result.data;
    else {
      return Promise.reject(result.error);
    }
  }
);

// 第一个参数为action，第二个参数为中间件处理的函数，一般用于发送axios请求
export const selectChantRecordAction = createAsyncThunk(
  "userManagement/selectChantRecord",
  async ({ userId, friendId, params }: any) => {
    // getUserChannels函数是一个axios的请求
    const result = await selectChantRecord(params);
    if (!result.error) return result.data;
    else {
      return Promise.reject(result.error);
    }
  }
);

// 第一个参数为action，第二个参数为中间件处理的函数，一般用于发送axios请求
export const selectGroupChantRecordAction = createAsyncThunk(
  "userManagement/selectGroupChantRecord",
  async ({ groupId, params }: any) => {
    // getUserChannels函数是一个axios的请求
    const result = await selectGroupChantRecord(groupId, params);
    if (!result.error) return result.data;
    else {
      return Promise.reject(result.error);
    }
  }
);

// 第一个参数为action，第二个参数为中间件处理的函数，一般用于发送axios请求
export const selectUserGroupAction = createAsyncThunk(
  "userManagement/selectUserGroup",
  async ({ userId, params }: any) => {
    // getUserChannels函数是一个axios的请求
    const result = await selectUserGroup(userId, params);
    if (!result.error) return result.data;
    else {
      return Promise.reject(result.error);
    }
  }
);

// 第一个参数为action，第二个参数为中间件处理的函数，一般用于发送axios请求
export const selectNextListAction = createAsyncThunk(
  "userManagement/selectNextList",
  async ({ userId, params }: any) => {
    // getUserChannels函数是一个axios的请求
    const result = await selectNextList(userId, params);
    if (!result.error) return result.data;
    else {
      return Promise.reject(result.error);
    }
  }
);

// 第一个参数为action，第二个参数为中间件处理的函数，一般用于发送axios请求
export const selectGroupListAction = createAsyncThunk(
  "userManagement/selectGroupList",
  async (params: any) => {
    // getUserChannels函数是一个axios的请求
    const result = await selectGroupList(params);
    if (!result.error) return result.data;
    else {
      return Promise.reject(result.error);
    }
  }
);

// drawing periods lotter
export const selectDrawListAction = createAsyncThunk(
  "userManagement/selectGroupList",
  async (params: any) => {
    // getUserChannels函数是一个axios的请求
    const result = await selectDrawList(params);
    if (!result.error) return result.data;
    else {
      return Promise.reject(result.error);
    }
  }
);

// 第一个参数为action，第二个参数为中间件处理的函数，一般用于发送axios请求
export const selectGroupManListAction = createAsyncThunk(
  "userManagement/selectGroupManList",
  async ({ groupId, params }: any) => {
    // getUserChannels函数是一个axios的请求
    const result = await selectGroupManList(groupId, params);
    if (!result.error) return result.data;
    else {
      return Promise.reject(result.error);
    }
  }
);

// 第一个参数为action，第二个参数为中间件处理的函数，一般用于发送axios请求
export const getUserAvatarAction = createAsyncThunk(
  "userManagement/getUserAvatar",
  async (filename: any) => {
    // getUserChannels函数是一个axios的请求
    const result = await getUserAvatar(filename);
    if (!result.error) return result.data;
    else {
      return Promise.reject(result.error);
    }
  }
);

// 第一个参数为action，第二个参数为中间件处理的函数，一般用于发送axios请求
export const exportUserAction = createAsyncThunk(
  "userManagement/exportUser",
  async (params: any) => {
    // getUserChannels函数是一个axios的请求
    const result = await exportUser(params);
    console.log(result);

    return result;
  }
);

// 第一个参数为action，第二个参数为中间件处理的函数，一般用于发送axios请求
export const exportGroupAction = createAsyncThunk(
  "userManagement/exportGroup",
  async (params: any) => {
    // getUserChannels函数是一个axios的请求
    const result = await exportGroup(params);
    console.log(result);

    return result;
  }
);

// exportUserFriends
export const exportUserFriendsAction = createAsyncThunk(
  "userManagement/exportUserFriends",
  async ({ list, userId }: any) => {
    // getUserChannels函数是一个axios的请求
    const result = await exportUserFriends(list, userId);
    return result.data;
  }
);

// exportUserFriends
export const exportUserNextAction = createAsyncThunk(
  "userManagement/exportUserNext",
  async ({ list, userId }: any) => {
    // getUserChannels函数是一个axios的请求
    const result = await exportUserNext(list, userId);
    return result.data;
  }
);

// exportUserFriends
export const exportUserGroupsAction = createAsyncThunk(
  "userManagement/exportUserGroups",
  async ({ list, userId }: any) => {
    // getUserChannels函数是一个axios的请求
    const result = await exportUserGroups(list, userId);
    return result.data;
  }
);

export const updateUserDetailAction = createAsyncThunk(
  "userManagement/updateUserDetail",
  async ({ data, userId }: any) => {
    // getUserChannels函数是一个axios的请求
    const result = await updateUserDetail(userId, data);
    return result.data;
  }
);
export const updateMerchantDetailAction = createAsyncThunk(
  "userManagement/updateMerchantDetail",
  async ({ data }: any) => {
    // getUserChannels函数是一个axios的请求
    const result = await updateMerchantDetail(data);
    return result.data;
  }
);
// 投诉记录
export const getUserReportConfigAction = createAsyncThunk(
  "userManagement/getUserReportConfig",
  async (params: any) => {
    // getUserChannels函数是一个axios的请求
    const result = await userReportConfig(params);
    if (!result.error) return result.data;
    else {
      return Promise.reject(result.error);
    }
  }
);

export const fixReportStatusAction = createAsyncThunk(
  "userManagement/fixReportStatus",
  async ({ data, reportId }: any) => {
    // getUserChannels函数是一个axios的请求
    const result = await fixReportStatus(reportId, data);
    return result.data;
  }
);

export const circleOffrienesConfigAction = createAsyncThunk(
  "userManagement/circleOffrienesConfig",
  async (params: any) => {
    const result = await circleOffrienesConfig(params);
    if (!result.error) return result.data;
    else {
      return Promise.reject(result.error);
    }
  }
);
export const GetUpdateCoin = createAsyncThunk(
  "userManagement/UpdateCoinFix",
  async ({ reportId, data }: any) => {
    // getUserChannels函数是一个axios的请求
    const result = await UpdateCoinFix(reportId, data);
    return result.data;
  }
);

export const GetGoldCoinAction = createAsyncThunk(
  "userManagement/UpdateCoinFix",
  async ({ id, data }: any) => {
    // getUserChannels函数是一个axios的请求
    const result = await giftCoinDetails(id, data);
    return result.data;
  }
);

// 提交
export const GetUpdatePrize = createAsyncThunk(
  "userManagement/UpdatePrizeFix",
  async ({ data }: any) => {
    // getUserChannels函数是一个axios的请求
    const result = await UpdatePrizeFix(data);
    return result.data;
  }
);

// 当前处于运行数据接口
export const selectdrawPeriodListAction = createAsyncThunk(
  "userManagement/drawPeriodList",
  async (params: any) => {
    // getUserChannels函数是一个axios的请求
    const result = await drawPeriodList(params);
    if (!result.error) return result.data;
    else {
      return Promise.reject(result.error);
    }
  }
);

// 第一个参数为action，第二个参数为中间件处理的函数，一般用于发送axios请求
export const selectprizesyncAction = createAsyncThunk(
  "userManagement/prizesyncList",
  async (params: any) => {
    // getUserChannels函数是一个axios的请求
    const result = await prizesyncList();
    if (!result.error) return result.data;
    else {
      return Promise.reject(result.error);
    }
  }
);